(function () {
  const BESTS = [1, 3, 5];

  function rngInt(match, n) {
    const box = { rngState: match.rng | 0 };
    const v = window.Kernel.rngInt(box, n);
    match.rng = box.rngState;
    return v;
  }

  function clone(x) {
    return JSON.parse(JSON.stringify(x));
  }

  function deckOf(source) {
    const deck = typeof source === "string" ? window.RB.Decklists.get(source) : source;
    if (!deck) return null;
    const out = clone(deck);
    if (!Array.isArray(out.side)) out.side = [];
    return out;
  }

  const Match = {
    BESTS: BESTS,

    needed(best) {
      return Math.floor(best / 2) + 1;
    },

    create(opts) {
      const best = BESTS.indexOf(opts.best) >= 0 ? opts.best : 1;
      const decks = [deckOf(opts.decks[0]), deckOf(opts.decks[1])];
      if (!decks[0] || !decks[1]) return null;
      const match = {
        v: 2,
        best: best,
        seed: opts.seed === undefined ? Math.floor(Math.random() * 2147483647) : (opts.seed | 0),
        rng: 0,
        names: [opts.names && opts.names[0], opts.names && opts.names[1]],
        ai: [(opts.ai && opts.ai[0]) || false, (opts.ai && opts.ai[1]) || false],
        registered: [decks[0], decks[1]],
        live: [clone(decks[0]), clone(decks[1])],
        presented: [{}, {}],
        wins: [0, 0],
        games: [],
        gameNo: 0,
        setup: null,
        choose: opts.choose === 0 || opts.choose === 1 ? opts.choose : null,
        pending: null,
        over: null,
      };
      match.rng = match.seed;
      Match.openPrep(match);
      return match;
    },

    isMatch(match) {
      return !!match && match.best > 1;
    },

    label(match) {
      return "Best of " + match.best;
    },

    openPrep(match) {
      match.gameNo++;
      match.setup = null;
      match.pending = {
        k: "present",
        game: match.gameNo,
        ready: [false, false],
        choice: [null, null],
      };
      if (Match.isMatch(match)) return;
      for (let p = 0; p < 2; p++) Match.submit(match, p, Match.autoPresent(match, p));
    },

    canSideboard(match) {
      return Match.isMatch(match) && match.gameNo > 1;
    },

    bfChoices(match, seat) {
      const all = (match.registered[seat].battlefields || []).slice();
      const used = match.presented[seat];
      const fresh = all.filter(function (id) { return !used[id]; });
      if (fresh.length) return fresh;
      return all.filter(function (id) { return (used[id] || 0) < 2; });
    },

    phase(match) {
      return match.pending ? match.pending.k : null;
    },

    prepFor(match, seat) {
      const pd = match.pending;
      if (!pd || pd.k !== "present") return null;
      return {
        game: pd.game,
        best: match.best,
        wins: match.wins.slice(),
        canSideboard: Match.canSideboard(match),
        choices: Match.bfChoices(match, seat),
        registered: match.registered[seat],
        live: match.live[seat],
        ready: pd.ready[seat],
        waiting: pd.ready[seat] && !pd.ready[seat === 0 ? 1 : 0],
      };
    },

    submitProblem(match, seat, choice) {
      const pd = match.pending;
      if (!pd || pd.k !== "present") return "this match is not waiting for a battlefield";
      if (pd.ready[seat]) return "that seat has already presented";
      if (Match.bfChoices(match, seat).indexOf(choice.bf) < 0) {
        return "that battlefield is not one this seat may still present";
      }
      if (choice.deck) {
        if (!Match.canSideboard(match)) return "no sideboarding before the first game of a match";
        const problem = window.RB.Decklists.swapProblem(match.registered[seat], choice.deck);
        if (problem) return problem;
        const errs = window.RB.Decklists.validate(choice.deck);
        if (errs.length) return errs[0];
      }
      return null;
    },

    submit(match, seat, choice) {
      const problem = Match.submitProblem(match, seat, choice);
      if (problem) return problem;
      const pd = match.pending;
      if (choice.deck) match.live[seat] = clone(choice.deck);
      pd.choice[seat] = { bf: choice.bf };
      pd.ready[seat] = true;
      if (pd.ready[0] && pd.ready[1]) Match.openTurnOrder(match);
      return null;
    },

    bothPresented(match) {
      const pd = match.pending;
      return !!pd && pd.k === "present" && pd.ready[0] && pd.ready[1];
    },

    rollOff(match) {
      const values = [0, 0];
      let guard = 0;
      do {
        values[0] = rngInt(match, 6) + 1;
        values[1] = rngInt(match, 6) + 1;
      } while (values[0] === values[1] && guard++ < 32);
      const designated = values[0] === values[1] ? rngInt(match, 2) : (values[0] > values[1] ? 0 : 1);
      return { values: values, designated: designated };
    },

    openTurnOrder(match) {
      const pd = match.pending;
      const bf = [pd.choice[0].bf, pd.choice[1].bf];
      const roll = match.choose === null || match.choose === undefined ? Match.rollOff(match) : null;
      if (roll) match.choose = roll.designated;
      const pick = Match.isMatch(match);
      match.pending = {
        k: "turnOrder",
        game: pd.game,
        bf: bf,
        roll: roll,
        designated: match.choose,
        pick: pick,
        first: pick ? null : true,
      };
    },

    turnOrderFor(match, seat) {
      const pd = match.pending;
      if (!pd || pd.k !== "turnOrder") return null;
      return {
        game: pd.game,
        bf: pd.bf.slice(),
        roll: pd.roll ? { values: pd.roll.values.slice(), designated: pd.roll.designated } : null,
        designated: pd.designated,
        pick: pd.pick,
        yours: pd.pick && pd.designated === seat,
        first: pd.first,
      };
    },

    chooseProblem(match, seat, first) {
      const pd = match.pending;
      if (!pd || pd.k !== "turnOrder") return "this match is not waiting on the turn order";
      if (!pd.pick) return "a duel rolls for the first player, nobody chooses (CR 485)";
      if (pd.first !== null) return "who plays first has already been decided";
      if (pd.designated !== seat) return "the other seat chooses who plays first";
      if (first !== true && first !== false) return "choose whether to play first";
      return null;
    },

    chooseFirst(match, seat, first) {
      const problem = Match.chooseProblem(match, seat, first);
      if (problem) return problem;
      match.pending.first = first;
      return null;
    },

    ready(match) {
      const pd = match.pending;
      return !!pd && pd.k === "turnOrder" && pd.first !== null;
    },

    autoPresent(match, seat) {
      const choices = Match.bfChoices(match, seat);
      return { bf: choices[rngInt(match, choices.length)] };
    },

    autoFirst(match) {
      return false;
    },

    buildSetup(match) {
      if (!Match.ready(match)) return null;
      const pd = match.pending;
      const seed = rngInt(match, 2147483647);
      const first = pd.first ? pd.designated : (pd.designated === 0 ? 1 : 0);
      const players = [0, 1].map(function (p) {
        return window.RB.Decklists.toSetupPlayer(match.live[p], match.names[p], { battlefields: [pd.bf[p]] });
      });
      const setup = {
        seed: seed,
        firstPlayer: first,
        ai: match.ai.slice(),
        decks: [match.live[0].id, match.live[1].id],
        players: players,
      };
      if (Match.isMatch(match)) {
        for (let p = 0; p < 2; p++) match.presented[p][pd.bf[p]] = (match.presented[p][pd.bf[p]] || 0) + 1;
        setup.match = { game: match.gameNo, best: match.best, wins: match.wins.slice() };
      }
      match.setup = setup;
      match.pending = null;
      return setup;
    },

    recordGame(match, game, winner) {
      if (match.over) return match.over;
      match.games.push({ setup: game.setup, log: game.log.slice() });
      match.wins[winner]++;
      if (match.wins[winner] >= Match.needed(match.best)) {
        match.over = { winner: winner, wins: match.wins.slice() };
        match.pending = null;
        return match.over;
      }
      match.choose = winner === 0 ? 1 : 0;
      Match.openPrep(match);
      return null;
    },

    score(match) {
      return match.wins[0] + "–" + match.wins[1];
    },
  };

  window.RB = window.RB || {};
  window.RB.Match = Match;
})();
